import { CallToActionCardProps } from '@molecules/*';
import { Fragment, FunctionComponent } from 'react';
import { BeforeYouStartTemplate } from '@templates';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { RoutesList } from '../../../routes/Routes';
import { useBuskingStore } from '../../../../hooks/useBuskingStore';
import {
  FORM_LINK_TEXT,
  FORM_LINK_SUBTEXT,
  CHAT_LINK_TEXT,
  CHAT_LINK_SUBTEXT,
} from '@constants';

const ASSISTANT_URL = import.meta.env.VITE_ASSISTANT_URL;

const linkObjectArrays = [
  {
    level: 1,
    title: 'Home',
    href: 'https://www.westminster.gov.uk/',
  },
  {
    level: 2,
    title: 'Report it',
    href: 'https://www.westminster.gov.uk/report-it',
  },
  {
    level: 3,
    title: `Report a busking or street entertainment issue`,
  },
];

const listItems = [
  'animal safety concerns',
  'excessive noise',
  'obstruction of roads or pavements',
  'breach of condition',
];

const performerDetails = [
  'the location',
  'time and date the issue happened',
  'a description of the performer',
];
const issueDetails = ['photos of the issue', 'your contact details'];

const contentTitle = 'Report a busking or street entertainment issue';
const ContentBody: FunctionComponent = () => {
  return (
    <>
      <h2 className="text-brand-primary text-h2 mt-4 font-semibold">
        Before you start
      </h2>
      <div className="text-bodyLg mt-4 flex flex-col gap-4">
        <p>
          We accept reports about busking and street performance issues that
          include:
        </p>
        <ul className="list-inside list-disc pl-3 leading-[28.5px]">
          {listItems.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
        <p>To help resolve the issue quickly, we need to know:</p>
        <ul className="list-inside list-disc pl-3 leading-[28.5px]">
          {performerDetails.map((performerDetail, index) => (
            <li key={index}>{performerDetail}</li>
          ))}
        </ul>
        <p>It’s useful to include:</p>
        <ul className="list-inside list-disc pl-3 leading-[28.5px]">
          {issueDetails.map((issueDetail, index) => (
            <li key={index}>{issueDetail}</li>
          ))}
        </ul>
      </div>
    </>
  );
};

export const BeforeYouStart: FunctionComponent = () => {
  const navigate = useNavigate();
  const sessionId = uuidv4();
  const { reset, update } = useBuskingStore();
  const initiateForm = () => {
    reset();
    update('sessionId', sessionId);
    navigate(RoutesList.ISSUE_TYPE);
  };

  const reportItCTA: CallToActionCardProps = {
    linkText: FORM_LINK_TEXT,
    linkSubtext: FORM_LINK_SUBTEXT,
    onClick: initiateForm,
  };

  const reportItAssistantRoute = `${ASSISTANT_URL}?category=busking_and_street_entertainment`;
  const reportItAssistantCTA: CallToActionCardProps = {
    linkText: CHAT_LINK_TEXT,
    linkSubtext: CHAT_LINK_SUBTEXT,
    externalHref: reportItAssistantRoute,
  };

  const callToActionCards = [reportItAssistantCTA, reportItCTA];

  return (
    <BeforeYouStartTemplate
      contentTitle={contentTitle}
      callToActionCards={callToActionCards}
      linkObjectArrays={linkObjectArrays}
      contentSubtext={<ContentBody />}
    />
  );
};
